import * as React from 'react';
import { ImageRef } from '../../../commonv3/types/image';
import { ImageApis } from '../../../commonv3/api/images';
import { RoundButton } from '../../../commonv3/components/atoms/buttons/RoundButton';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import './lessonProgressCard.module.scss';
import { V3Routes } from '../../routes';
import { CourseId } from '../../types/courses';
import { LessonId } from '../../types/lessons';

const ProgressBar = ({ progress }) => (
    <div styleName="progress-bar">
        <div styleName="bar-wrapper">
            <div styleName="bar" style={{ width: `${progress * 100}%` }} />
        </div>
        <div styleName="text">{Math.round(progress * 100)}%完了</div>
    </div>
);

const Thumbnail = ({ imageRef }) => (
    <div styleName="thumbnail-wrapper">
        <img src={ImageApis.getUrlFor(imageRef)} styleName="thumbnail" />
    </div>
);

const LessonInfo = ({ courseName, lessonIndex, lessonName }) => (
    <div styleName="lesson-info">
        <div styleName="course-name">{courseName}</div>
        <div styleName="lesson-row">
            <div styleName="lesson-index-label">DAY {lessonIndex}</div>
            <div styleName="lesson-name">{lessonName}</div>
        </div>
    </div>
);

type Props = {
    courseId: CourseId;
    lessonId: LessonId;
    progress: number;
    courseName: string;
    lessonIndex: number;
    lessonName: string;
    lessonThumbnail: ImageRef;
};

class NonSpLessonProgressCard extends React.Component<Props> {
    render() {
        const { courseId, lessonId, progress, courseName, lessonIndex, lessonName, lessonThumbnail } = this.props;
        return (
            <div
                styleName="card"
                id={`lesson-progress-card-${lessonId}`}
                onClick={() => GlobalStatesV3.routing.push(V3Routes.lesson(courseId, lessonId))}
            >
                <Thumbnail imageRef={lessonThumbnail} />
                <div styleName="desktop-right flex stretch">
                    <LessonInfo courseName={courseName} lessonIndex={lessonIndex} lessonName={lessonName} />
                    <ProgressBar progress={progress} />
                </div>
            </div>
        );
    }
}

class SpLessonProgressCard extends React.Component<Props> {
    render() {
        const { courseId, lessonId, progress, courseName, lessonIndex, lessonName, lessonThumbnail } = this.props;
        return (
            <div
                styleName="card"
                id={`lesson-progress-card-${lessonId}`}
                onClick={() => GlobalStatesV3.routing.push(V3Routes.lesson(courseId, lessonId))}
            >
                <div>
                    <LessonInfo courseName={courseName} lessonIndex={lessonIndex} lessonName={lessonName} />
                    <ProgressBar progress={progress} />
                </div>
                <Thumbnail imageRef={lessonThumbnail} />
            </div>
        );
    }
}

@observer
export class LessonProgressCard extends React.Component<Props> {
    render() {
        if (GlobalStatesV3.viewport.isNonSp) {
            return <NonSpLessonProgressCard {...this.props} />;
        }
        return <SpLessonProgressCard {...this.props} />;
    }
}
